import Popup from './popup';

export default class CourseCreationPopup extends Popup {
  createComponent() {
    return document.createElement(`au-${this.type}`);
  }

  setAttributes(courseCreationPopup, source) {
    courseCreationPopup.setAttribute('source', source);
  }
}
